import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
} from '@material-ui/core'
import classnames from 'classnames'
import CountUp from 'react-countup'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1),
  },
  differenceValueNegative: {
    color: colors.red[900],
    marginRight: theme.spacing(1),
  },
  noDifference: {
    color: colors.grey[900],
    marginRight: theme.spacing(1),
  },
}))

const BankCard = ({ total, tipo, positive, justRight }) => {
  const classes = useStyles()

  const contUp = money => {
    return (
      <CountUp
        end={money}
        duration={0.7}
        decimals={2}
        decimal=","
        prefix="R$"
        separator="."
      />
    )
  }

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {tipo}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h5"
              className={classnames({
                [classes.differenceValue]: positive,
                [classes.differenceValueNegative]: !positive,
              })}
            >
              {contUp(total)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default BankCard
